import { SyncService } from "frontend/services/syncService";
import { useSubscribe } from "replicache-react";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { canvasMetadataPrefix } from "shared/util/utils";
import { enablePatches, produceWithPatches } from "immer";

enablePatches();

export interface MappingTaskCardsToMonday {
  assignee: string;
  date: string;
  tags: string;
  // only for cards in gantt and task-cards with date-range (otherwise, use the date field)
  "date-tab": "start-end" | "timeline" | "";
  start_date: string;
  end_date: string;
  timeline: string;
}

export const EmptyMappingForTaskCards: MappingTaskCardsToMonday = {
  assignee: "",
  date: "",
  tags: "",
  "date-tab": "",
  start_date: "",
  end_date: "",
  timeline: "",
};

export function useMappingSettingsForTaskCards(syncService: SyncService<RW> | null, boardId?: string) {
  const key = `${canvasMetadataPrefix}IntgMapping-${boardId}`;

  const mapping = useSubscribe<MappingTaskCardsToMonday | undefined>(
    syncService?.getReplicache(),
    async (tx) => {
      return boardId ? (await tx.get(key)) ?? EmptyMappingForTaskCards : undefined;
    },
    undefined,
    [key]
  );

  const patchMapping = (newMapping: Partial<MappingTaskCardsToMonday>) => {
    const rep = syncService?.getReplicache();
    if (rep && boardId) {
      const [, patches] = produceWithPatches(mapping, (draft: MappingTaskCardsToMonday) => {
        for (const key in newMapping) {
          //@ts-expect-error I can't get the typing right here
          draft[key] = newMapping[key];
        }
      });
      rep.mutate.patchAnything({ id: key, patch: patches });
    }
  };

  return [mapping, patchMapping] as const;
}
